import { __assign } from "tslib";
import { createFakePutResponder } from './../../test-utils';
import { createFakeGetResponder } from '../../test-utils';
// tslint:disable-next-line:max-line-length
import { createEmailTemplatesApi } from './index';
import { createHttpTestKit } from '../../http/test-kit';
export var createEmailTemplatesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createEmailTemplatesApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetEmailTemplates: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/".concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        whenGetEmailTemplate: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/".concat(dto.locale, "/").concat(dto.type).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        whenUpdateEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/".concat(dto.locale, "/").concat(dto.type))(dto.data);
        },
        whenGetDefaultEmailTemplate: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/".concat(dto.locale, "/").concat(dto.type, "/default").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        whenEnableEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/notifications/".concat(dto.locale, "/").concat(dto.type, "/enable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''))({});
        },
        whenDisableEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/notifications/".concat(dto.locale, "/").concat(dto.type, "/disable").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''))({});
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map